import { render, staticRenderFns } from "./ActionsProveedor.vue?vue&type=template&id=0b6c74fa"
import script from "./ActionsProveedor.vue?vue&type=script&lang=js"
export * from "./ActionsProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports